import React, { memo, ReactElement } from 'react';
import { Helmet } from 'react-helmet';

const Dynamics = (): ReactElement => {
    return (
        <Helmet>
            <script
                async
                type="text/javascript"
                src="https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormCapture/FormCapture.bundle.js"
            ></script>
        </Helmet>
    );
};

export default memo(Dynamics);
